import { useDataAttributes } from '@data-attributes/use-data-attributes';
import { useInputs } from '@hooks/use-inputs';
import { useCalculatorConfig } from '@/calculator-config/use-calculator-config';

interface SliderInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    inputfieldkey: 'initialInvestment' | 'monthlyContribution' | 'savingPeriodYears';
}

const SliderInput = ({ inputfieldkey, ...rest }: SliderInputProps) => {
    const { calcInputs, setCalcInputs } = useInputs();
    const { includeSliders } = useCalculatorConfig();

    if (!includeSliders) {
        return null;
    }

    return (
        <input
            type="range"
            value={calcInputs[inputfieldkey]}
            onChange={({ target }) => {
                setCalcInputs({
                    ...calcInputs,
                    [inputfieldkey]: +target.value,
                });
            }}
            {...rest}
        ></input>
    );
};

export const InitialInvestmentSlider = () => {
    const { sliderInputDataAttrs } = useDataAttributes();

    return (
        <SliderInput
            name="initialInvestment"
            inputfieldkey="initialInvestment"
            {...sliderInputDataAttrs.initialInvestment}
        />
    );
};

export const MonthlyContributionSlider = () => {
    const { sliderInputDataAttrs } = useDataAttributes();

    return (
        <SliderInput
            name="monthlyContribution"
            inputfieldkey="monthlyContribution"
            {...sliderInputDataAttrs.monthlyContribution}
        />
    );
};

export const SavingPeriodYearsSlider = () => {
    const { sliderInputDataAttrs } = useDataAttributes();

    return (
        <SliderInput
            name="savingPeriodYears"
            inputfieldkey="savingPeriodYears"
            {...sliderInputDataAttrs.savingPeriodYears}
        />
    );
};
